module.exports = __webpack_public_path__ + "static/img/1.3fd67e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/1.png
// module id = Agjb
// module chunks = 0